export type UserType = {
  access_token?: string;
  has_active_plan?: boolean;
  email: string;
  firstName?: string;
  firstname?: string;
  name?: string;
  id: string;
  token: string;
  lastName?: string;
  lastname?: string;
  pnoe_auth_token?: string;
  pnoe_user_id?: string;
  refresh_token: string;
  trainer_id?: string;
  feedback_status?: string;
  welcome_screen_displayed?: boolean;
  biometrics_questionnaire_completed?: boolean;
  lifestyle_questionnaire_completed?: boolean;
  nutrition_questionnaire_completed?: boolean;
  has_lifestyle_questionnaire_access?: boolean;
  has_advanced_app_access?: boolean;
  role: UserRole;
  identity: string;
  origin?: string;
  isImport?: boolean;
  locations?: [];
  agentType?: string;
  unitType?: number;
  InBodyConnected?: boolean;
  InBodyAccount?: string;
  // 1 = a payment method is saved, 0 = none. Sourced from the GetUser response.
  paymentMethod?: number;
};

export type AffiliateUserType = {
  userID: string;
  companyType: number;
  role: UserRole;
  email: string;
  authenticationToken: string;
  token: string;
  refresh_token: string;
  name: string;
  isPnoeGrow: boolean;
  id: string;
  isActive: boolean;
  isProfileCompleted: boolean;
  identity: string;
  InBodyConnected?: boolean;
};

export enum UserRole {
  None,
  Customer,
  Company,
  Store,
  Employee,
  CompanyAdmin,
  Admin = 10,
}

export type ClientType = {
  id: string;
  firstName: string;
  lastName: string;
  gender: string;
  birthday: string;
  email: string;
  phone: string;
  country: string;
  address: string;
  zipcode: string;
  nutrition: boolean;
  workout: boolean;
  report: boolean;
  biomarker: boolean;
  dateCreated: string;
  pending: number;
  registered: number;
  status: string;
  origin: string;
  isImport?: boolean;
  prescription: boolean;
  approval?: number;
};
